import _ from 'lodash';

import { LS_KEYS } from 'client/redux/pubnub/constants';
import { EMOJI_TYPES } from 'client/types';

type Data = {
  [LS_KEYS.LS_RAISE_HAND_MSG_TT]: string | null;
  [LS_KEYS.LS_REACTION_MSG_TT]: string | null;
  [LS_KEYS.LS_REACTION_MSG_VALUE]: EMOJI_TYPES | null;
  isStatsUserCountAlreadySend: boolean | null;
  isStartBroadcastByMe: boolean | null;
  isListenerConnectedToCoversation: boolean | null;
  isShowHostFinishedPopup: boolean | null;
};

export const getData = (roomId: string): Data | null => {
  const rawData = window.localStorage.getItem(roomId);

  if (rawData) {
    return JSON.parse(rawData);
  }

  return null;
};

export const setData = (roomId: string, data: Partial<Data>) => {
  const currentData = getData(roomId) || {};
  const updatedData = _.merge(currentData, data);

  window.localStorage.setItem(roomId, JSON.stringify(updatedData));
};

export const roomInfoLS = {
  getData,
  setData,
};
